import React, { useMemo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile, isMobileLandscape } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import TournamentGame from './TournamentGame';
import TournamentPlayerList from './TournamentLobby/TournamentPlayerList';
import TournamentChat from './TournamentChat/TournamentChat';
import TournamentChatSend from './TournamentChat/TournamentChatSend';
import DurationTimer from '../../../../../Timer/DurationTimer';
import { formatCurrency } from '../../../../../../../helpers/format';
import { getGames,
  getTournamentGameUrls,
  getTournamentPlayers,
  getTournamentChatStatuses,
} from '../../../../../../../store/selectors';
import { openTournamentChat , closeTournamentChat } from '../../../../../../../store/actionCreators/tournamentCasinoChats';
import { requestTournamentGameUrl } from '../../../../../../../store/actionCreators/tournamentGameUrls';
import { getTournamentBuyinInfo } from './helpers/getTournamentBuyinInfo';

const prizeIcon = <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 18 18" version="1.1">
<title>23D3CEE7-E3F7-4B59-A3DA-8ED053643DE0@1.5x</title>
<desc>Created with sketchtool.</desc>
  <g id="Casino-Tournaments" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
      <g id="Gameplay" transform="translate(-13.000000, -13.000000)" fill="#EEEEEE" fill-rule="nonzero">
          <g id="Header">
              <path d="M26.75,30.5 L26.75,29.25 L26.2421875,29.25 C25.5130208,29.25 24.8815104,29.1783854 24.3476562,29.0351562 C23.8138021,28.8919271 23.4296875,28.7356771 23.1953125,28.5664062 C22.9609375,28.3971354 22.7721354,28.2083333 22.6289062,28 C22.4856771,27.7916667 22.4075521,27.6419271 22.3945312,27.5507812 C22.3815104,27.4596354 22.375,27.3880208 22.375,27.3359375 L22.375,26.046875 C22.9739583,25.8645833 23.5729167,25.4609375 24.171875,24.8359375 C25.265625,24.5755208 26.2682292,24.1197917 27.1796875,23.46875 C28.2473958,22.6875 29.0677083,21.7109375 29.640625,20.5390625 C30.2135417,19.3671875 30.5,17.7786458 30.5,15.7734375 L30.5,15.5 L27.3359375,15.5 C27.3880208,14.5885417 27.3880208,13.7552083 27.3359375,13 L16.125,13 L16.125,15.5 L13,15.5 L13,16.75 C13.0520833,18.1822917 13.3385417,19.4453125 13.859375,20.5390625 C14.4322917,21.7109375 15.2526042,22.6875 16.3203125,23.46875 C17.1796875,24.09375 18.1822917,24.5494792 19.328125,24.8359375 C19.9270833,25.4609375 20.5260417,25.8645833 21.125,26.046875 L21.125,27.453125 C20.9166667,28.6510417 19.6276042,29.25 17.2578125,29.25 L16.75,29.25 L16.75,30.5 L26.75,30.5 Z M18,23.0390625 C16.671875,22.3880208 15.6692708,21.3723958 14.9921875,19.9921875 C14.5494792,19.0546875 14.3020833,17.9739583 14.25,16.75 L16.2421875,16.75 C16.2942708,17.21875 16.3333333,17.5572917 16.359375,17.765625 C16.75,20.0052083 17.296875,21.7630208 18,23.0390625 Z M25.4609375,23.0390625 C26.1640625,21.7630208 26.7109375,20.0052083 27.1015625,17.765625 C27.1015625,17.6614583 27.1210938,17.4986979 27.1601562,17.2773438 C27.1992188,17.0559896 27.2317708,16.8802083 27.2578125,16.75 L29.25,16.75 C29.1979167,17.9739583 28.9505208,19.0546875 28.5078125,19.9921875 C27.8567708,21.3463542 26.8411458,22.3619792 25.4609375,23.0390625 Z" id="Close"/>
          </g>
      </g>
  </g>
</svg>

const closeIcon = <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 14 14" version="1.1">
<title>BC2B673F-55C4-45CF-B83D-29407DD6D1EE@1.5x</title>
<desc>Created with sketchtool.</desc>
<g id="Casino-Tournaments" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Gameplay---menu" transform="translate(-15.000000, -9.000000)" fill="#EEEEEE" fill-rule="nonzero">
        <g id="Group-15">
            <g id="Group-14">
                <path d="M27.2695312,23 C27.6210938,23 27.9140625,22.8828125 28.1484375,22.6484375 C28.3828125,22.4140625 28.5,22.1210938 28.5,21.7695312 C28.5,21.4179688 28.3828125,21.1132812 28.1484375,20.8554688 L23.5429688,16.25 L28.1484375,11.6445312 C28.3828125,11.3867188 28.5,11.0820312 28.5,10.7304688 C28.5,10.3789062 28.3828125,10.0859375 28.1484375,9.8515625 C27.9140625,9.6171875 27.6210938,9.5 27.2695312,9.5 C26.9179688,9.5 26.6132812,9.6171875 26.3554688,9.8515625 L21.75,14.4570312 L17.1445312,9.8515625 C16.8867188,9.6171875 16.59375,9.5 16.265625,9.5 C15.9375,9.5 15.6445312,9.6171875 15.3867188,9.8515625 C15.1289062,10.0859375 15,10.3789062 15,10.7304688 C15,11.0820312 15.1289062,11.3867188 15.3867188,11.6445312 L19.9570312,16.25 L15.3867188,20.8554688 C15.1289062,21.1132812 15,21.4179688 15,21.7695312 C15,22.1210938 15.1289062,22.4140625 15.3867188,22.6484375 C15.6445312,22.8828125 15.9375,23 16.265625,23 C16.59375,23 16.8867188,22.8828125 17.1445312,22.6484375 L21.75,18.0429688 L26.3554688,22.6484375 C26.6132812,22.8828125 26.9179688,23 27.2695312,23 Z" id="Close"/>
            </g>
        </g>
    </g>
</g>
</svg>

const TournamentGameWindow = ({ 
  id,
  game,
  gameFrameRef,
  tournamentCasino,
  onClose,
  onLobby,
  onLobbyFromGame,
  emitToSocket,
  setShowLobbyFromGame,
  showInfo,
  setShowInfo,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const games = useSelector(getGames);
  const gameId = game.id;
  const { tourId } = game;

  const g = useMemo(() => tournamentCasino.find(t => t.tournamentId === tourId), [games, gameId]);
  const { chipValue } = getTournamentBuyinInfo(g);

  const prizePool = useMemo(() => {
    if (!g || !g.prizePool) return '';

    return g.prizePool.value;
  }, [g]);

  
  const tournamentGameUrls = useSelector(getTournamentGameUrls);
  const playerList = useSelector(getTournamentPlayers)[g.tournamentId] || [];
  const player = playerList.find(s => s.self);

  // const el = document.getElementById('tournaments__game__scrollbars');
  // const playerPosition = el?.offsetHeight / 52 <= player?.place;

  const tournamentChatStatuses = useSelector(getTournamentChatStatuses);
  const tournamentChatStatus = tournamentChatStatuses[g.tournamentId] ?
    tournamentChatStatuses[g.tournamentId]
    : false;

  const changeChatState = () => {
    if (tournamentChatStatus) {
      dispatch(closeTournamentChat(g));
    } else {
      dispatch(openTournamentChat(g));
    }
  }

  const url = tournamentGameUrls[tourId];
  const windowSize = tournamentGameUrls.size || 'fullScreen';

  const duration = useMemo(() => {
    const now = moment();
    const endsAt = moment(g.endDate);
    const d = moment.duration(endsAt.diff(now));
    return d.asSeconds();
  }, [g]);

  useEffect(() => {
    console.log('tournamentGameUrls tournamentGameUrls ', tournamentGameUrls)
  },[tournamentGameUrls]);

  useEffect(() => {
    if (tournamentGameUrls[tourId] && tournamentGameUrls['urlFailed']) {
      onClose();
    }
  }, [tournamentGameUrls])

  useEffect(() => {
    if(g) {
      dispatch(requestTournamentGameUrl(g));
    }
  },[g]);

  const openLobby = useCallback(() => {
    setShowInfo(!showInfo);
    setShowLobbyFromGame(false);
  }, [showInfo]);

  return (
    <React.Fragment>
      <div className={`tournaments__game tournaments__popup`}>
        <div className="tournaments__game__overlay tournaments__popup__overlay" />
        <div className={`tournaments__game__window ${showInfo ? 'show-info' : ''}`}>
          <div className="tournaments__game__topbar">
            <div className='tournaments__game__title'>
              <div className="tournaments__game__title__sides">
                <div className="tournaments__game__title__left">
                  <span className="tournaments__game__control expanded" onClick={openLobby} >
                    {showInfo ? closeIcon : prizeIcon}
                  </span>
                  <span className="tournaments__game__title__position">{`${player ? `${t('position')}:  ${player.place}` : ''}`}</span>
                </div>
                <div className="tournaments__game__title__middle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="11px" viewBox="0 0 10 11" version="1.1">
                    <title>737F65B2-0CF3-449D-957F-43DBD6D0A28D@1.5x</title>
                    <desc>Created with sketchtool.</desc>
                    <g id="Casino-Tournaments" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                        <g id="Gameplay---menu-chat-keyboard" transform="translate(-188.000000, -10.000000)" fill="#EEEEEE" fill-rule="nonzero">
                            <g id="Group-15">
                                <g id="Group" transform="translate(60.000000, 8.000000)">
                                    <g id="Group-2" transform="translate(128.000000, 0.000000)">
                                        <path d="M5,12.375 C6.34375,12.375 7.4921875,11.8984375 8.4453125,10.9453125 C9.3984375,9.9921875 9.875,8.84375 9.875,7.5 C9.875,6.15625 9.3984375,5.0078125 8.4453125,4.0546875 C7.4921875,3.1015625 6.34375,2.625 5,2.625 L5,5.25 L5.375,5.25 L5.375,3.0234375 C6.53125,3.1171875 7.50390625,3.59375 8.29296875,4.453125 C9.08203125,5.3125 9.4765625,6.328125 9.4765625,7.5 C9.4765625,8.75 9.04296875,9.80859375 8.17578125,10.6757812 C7.30859375,11.5429688 6.25,11.9765625 5,11.9765625 C3.75,11.9765625 2.69140625,11.5429688 1.82421875,10.6757812 C0.95703125,9.80859375 0.5234375,8.75 0.5234375,7.5 C0.5234375,6.265625 0.9609375,5.2109375 1.8359375,4.3359375 L1.5546875,4.0546875 C0.6015625,5.0078125 0.125,6.15625 0.125,7.5 C0.125,8.84375 0.6015625,9.9921875 1.5546875,10.9453125 C2.5078125,11.8984375 3.65625,12.375 5,12.375 Z M5,8.0859375 C5.15625,8.0859375 5.29296875,8.02734375 5.41015625,7.91015625 C5.52734375,7.79296875 5.5859375,7.65625 5.5859375,7.5 C5.5859375,7.34375 5.5234375,7.203125 5.3984375,7.078125 C5.3828125,7.078125 5.375,7.0625 5.375,7.03125 L5.3515625,7.0078125 L4.671875,6.515625 C4.203125,6.171875 3.73046875,5.83203125 3.25390625,5.49609375 C2.77734375,5.16015625 2.53125,5 2.515625,5.015625 C2.5,5.03125 2.58984375,5.17578125 2.78515625,5.44921875 C2.98046875,5.72265625 3.2265625,6.0625 3.5234375,6.46875 C3.8203125,6.875 4.0390625,7.17578125 4.1796875,7.37109375 C4.3203125,7.56640625 4.4375,7.71875 4.53125,7.828125 L4.5546875,7.875 C4.6640625,8.015625 4.8125,8.0859375 5,8.0859375 Z" id="History"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                  </svg>
                  <DurationTimer isMobile={true} duration={duration} leadingZeros className="" />
                </div>
                <div className="tournaments__game__title__right">
                  <span className="tournaments__game__title__spins-count">{`${player ? `Spins:  ${player.spins}` : ''}`}</span>
                  {!showInfo && <span className="tournaments__game__control" onClick={onClose}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="11px" height="11px" viewBox="0 0 11 11" version="1.1">
                      <title>CA70E1D7-3B19-46EF-9E22-0CEB9FCF5AAE@1.5x</title>
                      <desc>Created with sketchtool.</desc>
                      <g id="Casino-Tournaments" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
                          <g id="Gameplay" transform="translate(-348.000000, -17.000000)" fill="#CCCCCC" fill-rule="nonzero">
                              <g id="Header">
                                  <path d="M357.542969,27.5 C357.816406,27.5 358.044271,27.4088542 358.226562,27.2265625 C358.408854,27.0442708 358.5,26.8164062 358.5,26.5429688 C358.5,26.2695312 358.408854,26.0325521 358.226562,25.8320312 L354.644531,22.25 L358.226562,18.6679688 C358.408854,18.4674479 358.5,18.2304688 358.5,17.9570312 C358.5,17.6835938 358.408854,17.4557292 358.226562,17.2734375 C358.044271,17.0911458 357.816406,17 357.542969,17 C357.269531,17 357.032552,17.0911458 356.832031,17.2734375 L353.25,20.8554688 L349.667969,17.2734375 C349.467448,17.0911458 349.239583,17 348.984375,17 C348.729167,17 348.501302,17.0911458 348.300781,17.2734375 C348.10026,17.4557292 348,17.6835938 348,17.9570312 C348,18.2304688 348.10026,18.4674479 348.300781,18.6679688 L351.855469,22.25 L348.300781,25.8320312 C348.10026,26.0325521 348,26.2695312 348,26.5429688 C348,26.8164062 348.10026,27.0442708 348.300781,27.2265625 C348.501302,27.4088542 348.729167,27.5 348.984375,27.5 C349.239583,27.5 349.467448,27.4088542 349.667969,27.2265625 L353.25,23.6445312 L356.832031,27.2265625 C357.032552,27.4088542 357.269531,27.5 357.542969,27.5 Z" id="close-Game"/>
                              </g>
                          </g>
                      </g>
                  </svg>
                  </span>}
                </div>
              </div>
            </div>
          </div>
          <div className="tournaments__game__body">
            <div className="tournaments__game__left">
              {!isMobileLandscape && <div className="tournaments__game__information">
                <DurationTimer duration={duration} leadingZeros className="tournaments__game__duration" />
                <div className="tournaments__game__info-wrapper">
                  {isMobile && <div className="tournaments__game__name">{`${g.tournamentName} | ${g.tournamentId}`}</div>}
                  <div className="tournaments__game__prize">
                    {/* will translate 'Total'  */}
                    <header className="tournaments__game__prize-title">Total {t('tournaments.prizePool')}:</header>
                    <div className="tournaments__game__prize-value">{chipValue({val: prizePool})}</div>
                  </div>
                </div>

              </div>}
              {isMobileLandscape && <div className="tournaments__game__information">
                <div className="tournaments__game__timer-title-prize__wrapper">
                  <span className="tournaments__game__title">{`${g.tournamentName} | ${g.tournamentId}`}</span>
                  <DurationTimer isMobileLandscape duration={duration} leadingZeros className="tournaments__game__duration" />
                  <div className="tournaments__game__prize">
                    {/* will translate 'Total'  */}
                    <header className="tournaments__game__prize-title">Total {t('tournaments.prizePool')}</header>
                    <div className="tournaments__game__prize-value">
                      {chipValue({val: prizePool})}
                    </div>
                  </div>
                </div>
                {tournamentChatStatus &&
                  <TournamentChat
                    tournamentId={g.tournamentId}
                    onClose={() => changeChatState()}
                  />
                }
                <TournamentChatSend
                  emitToSocket={emitToSocket}
                  tournamentId={g.tournamentId}
                  changeState={() => changeChatState()}
                  tournamentChatStatus={tournamentChatStatus}
                  sendOrOpen={true}
                  t={t}
                />
                <div className="tournaments__game__button--wrapper">
                  <button className="tournaments__game__button" onClick={() => {
                    onLobby()
                    onLobbyFromGame()
                  }}>
                    {t('tournaments.viewTournamentLobby')}
                  </button>
                </div>
              </div>
              }
              <div universal className="tournaments__game__scrollbars" id="tournaments__game__scrollbars">
                <TournamentPlayerList playerList={playerList} showMorePlayersMobile={true}  />
              </div>
              <div className="tournaments__game-chat-wrapper">
                {!isMobileLandscape && tournamentChatStatus && <div className="tournaments__game-chat-inner">
                  <TournamentChat
                    tournamentId={g.tournamentId}
                    onClose={() => changeChatState()}
                  />
                </div>}
                {!isMobileLandscape && <TournamentChatSend
                  emitToSocket={emitToSocket}
                  tournamentId={g.tournamentId}
                  changeState={() => changeChatState()}
                  tournamentChatStatus={tournamentChatStatus}
                  sendOrOpen={true}
                />}
              </div>
              <div className="tournaments__game__button-row">
                <button className="tournaments__buttons__lobby primary" onClick={() => {
                    onLobby();
                    onLobbyFromGame();
                  }}>
                  {t('tournaments.viewTournamentLobby')}
                </button>
              </div>
            </div>
            <TournamentGame
              url={url} 
              ref={gameFrameRef}
              size={windowSize}
              showInfo={showInfo}
            />
          </div>
        </div>
      </div>
    </React.Fragment>


  )
};

export default TournamentGameWindow;